import React from 'react';
import { Box, Divider } from '@mui/material';
import { Label16Bold, SettingPrimaryLabel } from 'components';

export const BoxOption = ({
  title,
  description,
  children,
  sx,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
  sx?: React.CSSProperties;
}) => <>
    <Box sx={{
      width: "80%",
      display: 'flex',
      gap: 30,
      px: 3,
      py: 2,
    }}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        ...sx,
        maxWidth: '210px',
        minWidth: '210px',
      }}>
        {sx ? <Label16Bold sx={{ mt: 1 }}>{title}</Label16Bold> : <Label16Bold>{title}</Label16Bold>}
        <SettingPrimaryLabel sx={{ mt: 2 }}>
          {description}
        </SettingPrimaryLabel>
      </Box>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}>
        {children}
      </Box>
    </Box>
    <Divider />
  </>